import React, { createContext, useRef, useEffect } from 'react';
import delay from 'lodash/delay';
import noop from 'lodash/noop';
import type { Props, ReloadContext } from './types';

const ReloadPageContext = createContext<ReloadContext>({ reloadPage: noop });

let rolesAndActorsRefetch: number;

export const ReloadPageProvider = (props: Props) => {
	const { actorsApi, rolesApi, children } = props;
	const componentMountTracker = useRef<boolean>(true);

	useEffect(
		() => () => {
			// Resetting it as  for functional component this will act as component will unmount
			componentMountTracker.current = false;
		},
		[],
	);
	const context: ReloadContext = {
		reloadPage: (): void => {
			clearTimeout(rolesAndActorsRefetch);
			rolesAndActorsRefetch = delay(async () => {
				if (rolesApi && actorsApi && actorsApi.refetch) {
					await rolesApi.onRefetch();
					if (componentMountTracker && componentMountTracker.current) {
						actorsApi && actorsApi.refetch();
					}
				}
			}, 1000);
		},
	};
	return <ReloadPageContext.Provider value={context}>{children}</ReloadPageContext.Provider>;
};

export const ReloadPageConsumer = ReloadPageContext.Consumer;

export default ReloadPageContext;
